/**
 * The rounded button in the header's trailing slot.
 *
 * One component for every such control — the language switch, the meal
 * layout, the headcount layout — because they sit side by side, and two of
 * them drifting into different shapes was noticed within a day.
 */

import { memo, type ReactNode } from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { colors, radius, sizing, space } from '../../theme';

export interface HeaderPillProps {
  onPress: () => void;
  accessibilityLabel: string;
  selected?: boolean;
  testID?: string;
  children: ReactNode;
}

export const HeaderPill = memo(function HeaderPill({
  onPress,
  accessibilityLabel,
  selected,
  testID,
  children,
}: HeaderPillProps) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      accessibilityState={selected === undefined ? undefined : { selected }}
      testID={testID}
      style={({ pressed }) => [styles.pill, pressed && styles.pressed]}
    >
      {children}
    </Pressable>
  );
});

const styles = StyleSheet.create({
  pill: {
    minWidth: sizing.touchTarget,
    height: 32,
    paddingHorizontal: space.sm,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: radius.full,
    borderWidth: 1,
    borderColor: colors.border.default,
    backgroundColor: colors.bg.brandSubtle,
  },
  pressed: {
    opacity: 0.7,
  },
});
